// extracted by mini-css-extract-plugin
module.exports = {"bar":"_CalendarView_bar__2KiTI","date":"_CalendarView_date__hy_16","arrows":"_CalendarView_arrows__3XZJJ"};